import { User } from "../../models/user";
import { Encounter } from "../../models/encounter";
import { AdjustedMedicalBill, MedicalBill, DraftMedicalBill, MedicalBillSubmission, RepricedMedicalBill } from "../../models/medical-bill";

export namespace MedicalStateActions
{
    export class AppLoaded
    {
        static readonly type = "[App] App Loaded";
    }

    export class ProcessorLoaded {
        static readonly type = "[MedicalBillProcessor] Loaded Medical Bill Processor"
        constructor() { };
    }

    export class UserLoggedIn 
    {
      static readonly type = "[Login Action] User Logged In";
      constructor(public payload: { user: User }) {}
    }

    export class StartProcessingMedicalBillSubmission
    {
        static readonly type="[MedicalBillProcessor] Started Processing Submission";
        constructor(public payload: {submission: MedicalBillSubmission}){} 
    }

    export class MedicalBillProcessorMedicalBillSubmitted
    {
        static readonly type="[MedicalBillProcessor] Medical Bill Submitted";
        constructor(public payload: {submission:MedicalBillSubmission}){}
    }

    export class MedicalBillProcessorMedicalBillBeingAnalyzed
    {
        static readonly type="[MedicalBillProcessor] Medical Bill Being Analyzed";
        constructor(public payload: {submission:MedicalBillSubmission}){}
    }

    export class MedicalBillProcessorIdentifyingPatient
    {
        static readonly type="[MedicalBillProcessor] Identifying Patient";
        constructor(public payload: {submission:MedicalBillSubmission}){}
    }
    
    export class MedicalBillProcessorIdentifyingProviders
    {
        static readonly type="[MedicalBillProcessor] Identifying Providers";
        constructor(public payload: {submission:MedicalBillSubmission}){}
    }
    
    export class MedicalBillProcessorProcessingLines
    {
        static readonly type="[MedicalBillProcessor] Processing Lines";
        constructor(public payload: {submission:MedicalBillSubmission}){}
    }
    
    export class MedicalBillProcessorMedicalBillProcessingComplete
    {
        static readonly type="[MedicalBillProcessor] Medical Bill Processing Complete";
        constructor(public payload: {submission:MedicalBillSubmission, draftBill:DraftMedicalBill,succeeded: boolean}){}
    }

    export class RefreshBillSubmissions
    {
        static readonly type="[Any] Refresh Bill Submissions";
    }

    export class RefreshUnconfirmedBills
    {
        static readonly type="[Any] Refresh Unconfirmed Bills";
    }

    export class RefreshConfirmedBills
    {
        static readonly type="[Any] Refresh Confirmed Bills";
    }
    export class RefreshPayers
    {
        static readonly type="[Any] Refresh Payers";
    }

    export class RefreshSenders
    {
        static readonly type="[Any] Refresh Senders";
    }
    export class RefreshLockedBills
    {
        static readonly type="[Any] Refresh Locked Repriced Bills";
    }
    export class RefreshBillsAwaitingPayment
    {
        static readonly type="[Any] Refresh Repriced Bills Awaiting Payment";
    }

    export class MedicalBillServiceMedicalBillConfirmed<E extends Encounter>
    {
        static readonly type="[MedicalBillService] Medical Bill Confirmed";
        constructor(public payload: {draft:DraftMedicalBill, medicalBill: MedicalBill<E>}){} 
    }

    export class MedicalBillAdjusted<E extends Encounter>
    {
        static readonly type="[MedicalBillService] Medical Bill Adjusted";
        constructor(public payload: {bill: MedicalBill<E>, adjustedBill: AdjustedMedicalBill<E>}){}
    }

    export class AdjustedBillVoided<E extends Encounter>
    {
        static readonly type="[MedicalBillService] Adjusted Bill Voided";
        constructor(public payload: {adjustedBill: AdjustedMedicalBill<E>}) {}
    }

    export class AdjustedBillRepriced<E extends Encounter>
    {
        static readonly type="[MedicalBillService] Adjusted Bill Repriced";
        constructor(public payload: {adjustedBill: AdjustedMedicalBill<E>, repricedBill: RepricedMedicalBill<E>}){} 
    }
    export class RepricedBillVoided<E extends Encounter>
    {
        static readonly type="[MedicalBillService] Repriced Bill Voided";
        constructor(public payload: {repricedBill: RepricedMedicalBill<E>}) {}
    }

    export class RepricedBillLocked<E extends Encounter>
    {
        static readonly type="[MedicalBillService] Repriced Bill Locked";
        constructor(public payload: {repricedBill: RepricedMedicalBill<E>}) {}
    }
    export class BillSentToClearingHouse<E extends Encounter>
    {
        static readonly type="[MedicalBillService] Repriced Bill Sent To Clearing House";
        constructor(public payload: {repricedBill: RepricedMedicalBill<E>}) {}
    }

    export class MedicalBillDeleted<E extends Encounter>
    {
        static readonly type="[MedicalBillService] Medical Bill Deleted";
        constructor(public payload: {bill: MedicalBill<E>}){}
    }

    export class DraftMedicalBillDeleted
    {
        static readonly type="[MedicalBillService] Draft Medical Bill Deleted";
        constructor(public payload: {bill: DraftMedicalBill}){}
    }
}